import { createSession, getSessionValue } from './session'
import { http } from '../../core/services/http'

export const login = async (phone: string, password: string) => {
  const response = await http.post('/operations/auth/login', {
    phone,
    password,
  })
  const user = { phone: phone, token: response.data.access_token }
  createSession(
    `${response.data.token_type} ${response.data.access_token}`,
    response.data.refresh_token,
    { phone },
    { value: 'en-US', label: 'English' },
  )

  return user
}

export const getAuthToken = () => getSessionValue('authToken', '')
export const getRefreshToken = () => getSessionValue('refreshToken', '')
export const getUser = () => getSessionValue('user', undefined)
export const getTranslation = () =>
  getSessionValue('language', {
    value: 'en-US',
    label: 'English',
  })

export const logout = () => {
  return http.post('/operations/auth/logout', {
    refreshToken: getRefreshToken(),
  })
}

export const requestForgotPasswordCode = (
  phone: string,
  captchaResponse: string,
) =>
  http.post('/operations/auth/request-forgot-password-code', {
    phone,
    captchaResponse,
    agent: 'WEB',
  })

export const validateForgotPasswordCode = (phone: string, smsCode: string) =>
  http.post<{ validationCode: string; valid: boolean }>(
    '/operations/auth/validate-forgot-password-code',
    { phone, smsCode },
  )

export const forgotPassword = (
  phone: string,
  password: string,
  validationCode: string,
) =>
  http.post('/operations/auth/forgot-password', {
    phone,
    password,
    validationCode,
  })
